import React from 'react';
import TextField from '@mui/material/TextField';
import Tooltip from '@mui/material/Tooltip';
import { ThemeProvider } from '@mui/material/styles';
import constants from '../../utils/constants';

const index = ({ value, className, mode, maxLength, disabled, id, name, help, onChange, design, onBlur, onFocus, mandatory }) => {

  const handleFocus = (event, newValue) => {
    if (onFocus) {
      onFocus(event, newValue);
    }
  };

  const handleChange = (event) => {
    onChange(event);
  };

  const onFormatNumber = (e) => {
    onBlur(e);
  }

  //const inputWidth = value ? (value.length > 20 ? `${Math.min(value.length, 256)}ch` : '') : '5px';
  //const inputWidth = value ? (value.length > 20 ? `${Math.min(value.length, 256)}ch` : '') : (name.length * 5);
  //const inputWidth = value ? (value.length > name.length ? (value.length < 20 ? `${value.length * 7 - 2}px` : `${value.length * 5.6 - 2}px`) : `${name.length * 6.25}px`) : (name.length * 10);
  //const inputWidth = value ? (value.length > name.length ? (value.length < 20 ? `${value.length * 7 - 2}px` : `${value.length * 5.6 - 2}px`) : `${name.length * 6.25}px`) : "0px";
  //const minWidth = name.length + "em"

  //const inputWidth = value ? (value.length > name.length ? `${value.length * 7 - 2}px` : `${name.length * 6.25}px`) : name.length + "em";
  const inputWidth = value ? `${value.length}ch` : '0ch';
  const minWidth = name ? name.length + "ch" : "0ch";

  return (
    <ThemeProvider theme={constants.CUSTOM_MUI_TEXT_FIELD_THEME}>
      <Tooltip title={help} placement="top">
        <TextField
          inputProps={{ maxLength: maxLength, readOnly: mode, style: { fontVariantNumeric: 'tabular-nums',height: '1px', width: inputWidth, minWidth: minWidth, fontSize: "inherit", fontWeight: '600', lineHeight: "inherit", paddingRight: "8px", paddingLeft: "0px", textAlign: 'right', letterSpacing: "0.01rem" } }}
          disabled={disabled}
          key={id}
          id={id}
          //type="number"
          InputLabelProps={{ shrink: true, style: { fontSize: "inherit", fontWeight: '600', lineHeight: "inherit", marginTop: !value ? '-8px' : '' } }}
          label={design !== 'table' ? <span>
            {name}
            {mandatory ? <span style={{ color: 'red' }}> *</span> : ''}
          </span> : null}
          variant="outlined"
          value={value}
          onChange={handleChange}
          className={className ?? undefined}
          onBlur={onFormatNumber}
          onFocus={(event, newValue) => handleFocus(event, newValue)}
        />
      </Tooltip>
    </ThemeProvider>
  )
}

export default index